export default __webpack_public_path__ + "5081253185c5c701918294e93b640883.png";